import { useEffect } from 'react';
import { useAnimatedRouteContext } from './AnimatedRoute';
const useRegisterProducts = (productUuid, el) => {
    const { registerProducts, unregisterProducts } = useAnimatedRouteContext();
    useEffect(() => {
        if (productUuid && el.current) {
            registerProducts({
                el,
                productUuid,
            });
        }
        return () => {
            if (productUuid) {
                unregisterProducts(productUuid);
            }
        };
    }, [productUuid]);
};
export default useRegisterProducts;
